import {useEffect, useState} from "react";
import {Blockquote, Table} from "@wfp/ui";
import {useTranslation} from "react-i18next";
import {KVPair, ListPage, DetailedOrderBySchoolReport, Sortable} from "../../../models/types";
import {TablePagination} from "../../commons/table-pagination/table-pagination";

interface Props {
    hidePagination?: boolean;
    page?: ListPage<DetailedOrderBySchoolReport>;
    loadPage: (page: number, pageSize?: number, filtering?: KVPair[], sorting?: string[]) => void;
    sort?: (field: string) => void;
    sortInfo?: Sortable[];
}

const headers = ["order_id", "reference_number", "school_cerd", "school_name", "order_status", "partner_short_name", "supplier_name"];

const sort: Sortable[] = [
    {code: 'order_id', field: 'order__pk', enabled: true, mode: 0},
    {code: 'reference_number', field: 'pk', enabled: true, mode: 0},
    {code: 'school_cerd', field: 'school__cerd', enabled: true, mode: 0},
    {code: 'school_name', field: 'school_name', enabled: true, mode: 0},
    {code: 'order_status', field: 'order__state', enabled: true, mode: 0},
    {code: 'partner_short_name', field: 'order__partner', enabled: true, mode: 0},
    {code: 'supplier_name', field: 'order__supplier', enabled: true, mode: 0}
];

export function DetailedOrderBySchoolTable(props: Props) {
    const {t} = useTranslation();
    const [sortables, setSortables] = useState<Sortable[]>(sort);

    useEffect(() => {
        if (!!props.sortInfo) {
            const sorts = headers.map((header) => {
                const sort = props.sortInfo?.find((sort) => sort.code === header);
                return !!sort ? sort : {code: header, field: header, mode: 0, enabled: false}
            });
            setSortables(sorts);
        }
    }, [props.sortInfo]);


    function handleSorting(idx: number) {
        if (!!sortables && !!props.sort && !!props.page?.count && props.page?.count > 0) {
            const sortable = sortables[idx];
            if (!sortable.enabled) {
                return;
            }
            sortable.mode = (sortable.mode + 1) % 3;
            setSortables([...sortables]);
            const value = sortable.mode === 1 ? `+${sortable.field}` : sortable.mode === 2 ? `-${sortable.field}` : sortable.field;
            props.sort(value);
        }
    }

    return (
        <>
            {!!props.page && (
            <>
                <Table>
                    <thead>
                    <tr className="item-row-head">
                        {headers.map((header, idx) => (
                            <th key={idx} onClick={() => handleSorting(idx)}
                                className={props.sort && sortables?.at(idx)?.enabled && !!props.page?.count && props.page?.count > 0 ? "!text-center cursor-pointer" : "!text-center"}>
                                {t(header)}
                                {!!sortables?.length && !!props.page?.count && props.page?.count > 0 && (
                                    <span className="ml-0.5">
                                    {sortables[idx].mode === 2 ? '\u25bc' : sortables[idx].mode === 0 ? '\u2000' : '\u25b2'}
                                </span>
                                )}
                            </th>
                        ))}
                    </tr>
                    </thead>
                    {!!props.page && (
                        <tbody>
                        {props.page.results.map((item: DetailedOrderBySchoolReport, idx) => (
                            <tr className="item-row" key={idx}>
                                <td className="item-col text-center">
                                    {item.orderId}
                                </td>
                                <td className="item-col text-center">
                                    {item.referenceNumber}
                                </td>
                                <td className="item-col text-start">
                                    {item.schoolCerd}
                                </td>
                                <td className="item-col text-start">
                                    {item.schoolName}
                                </td>
                                <td className="item-col text-center">
                                    {item.orderStatus}
                                </td>
                                <td className="item-col text-start">
                                    {item.partnerShortName}
                                </td>
                                <td className="item-col text-start">
                                    {item.supplierName}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    )}
                </Table>
                {!props.hidePagination && (
                    <TablePagination page={props.page} loadPage={props.loadPage}/>
                )}
            </>
            )}
            {!props.page && (
                <Blockquote>
                    <p>{t('select_date_and_click_apply')}</p>
                </Blockquote>
            )}
        </>
    )
}
